import {
  absoluteImage,
  absoluteUrl,
  DEFAULT_SEO_PUBLISHER,
  stripHtml,
} from "../config/seo";

const truncate = (s: string, maxLen: number) => {
  const text = s.trim();
  if (!text) return "";
  if (text.length <= maxLen) return text;
  return `${text.slice(0, maxLen).trim()}...`;
};

export const buildvideosDescription = (videos: any) => {
  const html = videos?.description ?? videos?.intro ?? "";
  const text = stripHtml(html);
  return truncate(text, 160);
};

export const buildvideosKeywords = (videos: any) => {
  const parts = [videos?.author, videos?.videosLanguage, videos?.name]
    .map((v: any) => (v ? String(v).trim() : ""))
    .filter(Boolean);

  const uniq: string[] = [];
  for (const p of parts) {
    const key = p.toLowerCase();
    if (!uniq.some((x) => x.toLowerCase() === key)) uniq.push(p);
  }

  return uniq.join(", ");
};

export const buildvideosJsonLd = (videos: any, canonicalPath: string) => {
  const url = absoluteUrl(canonicalPath);
  const seoImage = videos?.ogImage || videos?.videosPath || "";
  const image = seoImage ? absoluteImage(seoImage) : "";
  const description = buildvideosDescription(videos);
  const authorName = videos?.author ? String(videos.author).trim() : "";
  const name = videos?.name ? String(videos.name).trim() : "";
  const inLanguage = videos?.videosLanguage ? String(videos.videosLanguage).trim() : "";

  const jsonLd: Record<string, any> = {
    "@context": "https://schema.org",
    "@type": "videos",
    name: name || undefined,
    url: url || undefined,
    ...(description ? { description } : {}),
    ...(image ? { image } : {}),
    ...(authorName ? { author: { "@type": "Person", name: authorName } } : {}),
    ...(inLanguage ? { inLanguage } : {}),
    publisher: { "@type": "Organization", name: DEFAULT_SEO_PUBLISHER },
  };

  // Remove undefined properties so schema is cleaner.
  for (const key of Object.keys(jsonLd)) {
    if (jsonLd[key] === undefined) delete jsonLd[key];
  }

  return jsonLd;
};

